<template>
	<div class="workspace-planning">
		<h3 class="highlight-orange-text">
			Welcome to NymbleUp Workforce Planning
		</h3>
		<div class="workspace-requirement-heading">
			How do you wish to plan your workspace requirment
		</div>
		<div class="workspace-planning-container">
			<div class="hour-type-section">
				<p class="text-sm hour-type-column">Category wise work hour</p>
				<el-radio v-model="selected_hour_type" label="category_wise">
					<span v-if="selected_hour_type === 'category_wise'">Yes</span>
					<span v-else> No</span>
				</el-radio>
				<p class="text-sm">
					<a href="/">See Tutorial</a>
				</p>
			</div>
			<p class="highlight-orange-text or-option">or</p>
			<div class="hour-type-section">
				<p class="text-sm hour-type-column">Transaction per hour</p>
				<el-radio v-model="selected_hour_type" label="transaction_wise">
					<span v-if="selected_hour_type === 'transaction_wise'">Yes</span>
					<span v-else> No</span>
				</el-radio>
				<p class="text-sm">
					<a href="/">See Tutorial</a>
				</p>
			</div>
			<div class="py-4">
				<div class="" style="width: 6rem;">
					<BaseButton
						type="submit"
						buttonclass="btn p-2 text-xs"
						@click="redirectToUrl()"
					>
						Save
					</BaseButton>
					&nbsp;
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "WorkspacePlanning",
	mixins: [],
	props: [],
	data() {
		return {
			selected_hour_type: "category_wise"
		};
	},
	methods: {
		redirectToUrl() {
			if (this.selected_hour_type === "category_wise") {
				this.$router.push({ name: "StoreDetails" }).catch(()=>{});
			} else {
				this.$router.push({ name: "Report" }).catch(()=>{});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./WorkspacePlanning.scss";
</style>
